// API Endpoints
export const API_ENDPOINTS = {
    LOGIN: "/wp-json/pg/v1/user/login",
    LOGOUT: "/wp-json/pg/v1/user/logout",
    AUTH_STATUS: "/wp-json/pg/v1/user/auth-status",
    CREATE_ACCOUNT: "/wp-json/pg/v1/user/create-account",
    CREATE_ACCOUNT_POST_PURCHASE: "/wp-json/pg/v1/user/create-account-post-purchase",
    CREATE_ACCOUNT_FROM_EMAIL: "/wp-json/pg/v1/user/create-account-from-email",
    FORGOT_PASSWORD: "/wp-json/pg/v1/user/forgot-password",
    FORGOT_UPDATE_PASSWORD: "/wp-json/pg/v1/user/forgot-update-password",
    USER_EXISTS: "/wp-json/pg/v1/user/userexists",
    VALIDATE_RECAPTCHA: "/wp-json/pg/v1/user/validate-recaptcha",
    USER_SAW_BANNER: "/wp-json/pg/v1/user/sawbanner",
} as const;

// Validation
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const MIN_PASSWORD_LENGTH = 8;

// Page Routes
export const ROUTES = {
    HOME: "/",
    LOGIN: "/login",
    COURSES: "/courses",
    COURSE_LESSON: "/courses/:course/:lessonName",
    COURSE_DETAIL: "/courses/:courseName",
    COURSE_EXPLORE: "/courses/explore-all/:category",
    DASHBOARD: "/my-game",
    DASHBOARD_EXPLORE: "/my-game/explore-all/:category",
    SCRATCH_CLUB: "/scratch-club",
    SCRATCH_CLUB_RECORD: "/scratch-club/record",
    SCRATCH_CLUB_ACCELERATOR_LESSON: "/scratch-club/:accelerator/:course/:lessonName",
    SCRATCH_CLUB_ACCELERATOR_COURSE: "/scratch-club/:accelerator/:courseName",
    SCRATCH_CLUB_ACCELERATOR: "/scratch-club/:accelerator",
    ORDER_STATUS: "/order-status",
    GIFT: "/gift/",
    THANK_YOU: "/thank-you/",
    FORGOT_PASSWORD: "/forgot-password",
    CREATE_ACCOUNT: "/create-account",
    CONTACT_US: "/contact-us",
    CONTACT_EXTERNAL: "https://www.performancegolf.com/contact",
    VIP_COACHING: "/vip-coaching",
    ACCOUNT: "/account",
    ACCOUNT_MANAGE: "/account/manage",
    ACCOUNT_PASSWORD: "/account/password",
} as const;

export function isPublicAuthFlowPath(pathname: string): boolean {
    const p = pathname.replace(/\/$/, "") || "/";
    return (
        p === ROUTES.LOGIN ||
        p === ROUTES.CREATE_ACCOUNT ||
        p === ROUTES.FORGOT_PASSWORD
    );
}

// Error messages
export const DEFAULT_LOGIN_ERROR =
    "Credentials not accepted. Please check that email, password, and login method are correct, then try again. If the problem persists, try resetting your password or contact customer support.";
